<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chap-acw"><a id="a83"></a>General Acknowledgements</h2>
<p class="noindent"><a id="page_ix"></a>I gratefully acknowledge the invaluable help of Bobby Gainher in editing the manuscript and saving me from many errors, and for my son’s computer expertise in preparing the maps.</p>
<a id="page_x"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_FM.vue?23c65303